import styled from "styled-components";
import { Flex, Icon } from "@evergis/ui";

export const ViewTypeContainer = styled(Flex)`
  flex-wrap: nowrap;
  margin: 0 1rem;
`;

export const TableViewIcon = styled(Icon)`
  margin-top: -0.5rem;

  &:after {
    font-size: 1.5rem;
  }
`;
